import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Privacy Policy</h1>
        <p style={styles.updated}>Last updated: [DATE — fill in when published]</p>

        <p style={styles.p}>
          This Privacy Policy explains what information GrubClub
          ("we," "us," or "our") collects, how we use it, and who we share it with.
        </p>

        <h2 style={styles.h2}>1. Information We Collect</h2>
        <p style={styles.p}><strong>Account information:</strong> your name, email address, and password (stored as a secure hash, never in plain text).</p>
        <p style={styles.p}><strong>Content you provide:</strong> recipes, ingredients, instructions, notes, and photos you upload; messages you send us (e.g. support requests).</p>
        <p style={styles.p}><strong>Payment information:</strong> processed directly by Stripe, our payment provider — we do not store your full card number ourselves.</p>
        <p style={styles.p}><strong>Usage information:</strong> basic activity like login timestamps, which we use to understand how the app is being used and to support your account.</p>

        <h2 style={styles.h2}>2. How We Use Your Information</h2>
        <p style={styles.p}>We use your information to:</p>
        <ul style={styles.ul}>
          <li>Provide and operate the Service (creating your account, storing your recipes, processing payments)</li>
          <li>Send you emails you'd expect — group invites, password resets, and support responses</li>
          <li>Extract recipe data from photos you submit to the "Scan Recipe" feature (see below)</li>
          <li>Maintain and improve the Service, including troubleshooting issues</li>
        </ul>

        <h2 style={styles.h2}>3. Who We Share Information With</h2>
        <p style={styles.p}>
          <strong>Other members of your Cookbook Club group:</strong> recipes and
          photos you add are visible to everyone in your group — that's the intended
          purpose of the app.
        </p>
        <p style={styles.p}>
          <strong>Service providers we use to run the app:</strong>
        </p>
        <ul style={styles.ul}>
          <li><strong>Stripe</strong> — payment processing</li>
          <li><strong>Supabase</strong> — storage for recipe photos</li>
          <li><strong>Anthropic (Claude AI)</strong> — when you use the "Scan Recipe" feature, the photo you provide is sent to Anthropic's API to extract recipe text. Only photos you actively submit for scanning are sent — not your other recipe photos.</li>
          <li><strong>Hostinger</strong> — website hosting, database, and outgoing email (invites, password resets)</li>
        </ul>
        <p style={styles.p}>
          We do not sell your personal information to third parties, and we don't
          share it for advertising purposes.
        </p>

        <h2 style={styles.h2}>4. Data Retention and Deletion</h2>
        <p style={styles.p}>
          We keep your information for as long as your account is active. If you'd
          like your account or your group's data deleted, contact us at{' '}
          <a href="mailto:support@cactuscreative.net">support@cactuscreative.net</a>{' '}
          and we'll process your request.
        </p>

        <h2 style={styles.h2}>5. Cookies and Local Storage</h2>
        <p style={styles.p}>
          We use your browser's local storage to keep you logged in between visits
          (storing a login token). We don't use third-party advertising trackers.
        </p>

        <h2 style={styles.h2}>6. Children's Privacy</h2>
        <p style={styles.p}>
          The Service is not directed at children, and we don't knowingly collect
          information from children under 13.
        </p>

        <h2 style={styles.h2}>7. Your Rights</h2>
        <p style={styles.p}>
          You can request access to, correction of, or deletion of your personal
          information at any time by contacting us at{' '}
          <a href="mailto:support@cactuscreative.net">support@cactuscreative.net</a>.
        </p>

        <h2 style={styles.h2}>8. Changes to This Policy</h2>
        <p style={styles.p}>
          We may update this Privacy Policy from time to time. We'll update the "Last
          updated" date above when we do.
        </p>

        <h2 style={styles.h2}>9. Contact</h2>
        <p style={styles.p}>
          Questions about this policy? Contact us at{' '}
          <a href="mailto:support@cactuscreative.net">support@cactuscreative.net</a>.
        </p>

        <p style={styles.disclaimer}>
          This document is a general template and has not been reviewed by an attorney.
          It's provided as a starting point, not legal advice.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '760px', margin: '40px auto', padding: '0 20px' },
  card: {
    backgroundColor: 'white', padding: '40px', borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', color: '#444', lineHeight: 1.6,
  },
  h1: { color: '#e67e22', marginBottom: '4px' },
  updated: { color: '#999', fontSize: '13px', marginBottom: '24px' },
  h2: { color: '#333', fontSize: '18px', marginTop: '28px', marginBottom: '10px' },
  p: { fontSize: '14px', marginBottom: '12px' },
  ul: { fontSize: '14px', marginBottom: '12px', paddingLeft: '22px' },
  disclaimer: { fontSize: '12px', color: '#aaa', marginTop: '32px', borderTop: '1px solid #f0f0f0', paddingTop: '16px' },
};

export default PrivacyPolicy;
